import React from "react";
import "../styles/GlobalStyles.css";

const Footer = () => (
  <footer
    style={{
      background: "var(--dark)",
      color: "rgba(255,255,255,0.55)",
      padding: "28px 18px",
      textAlign: "center",
      fontSize: "0.8rem",
      letterSpacing: "0.04em"
    }}
  >
    <p
      style={{
        fontFamily: "var(--font-serif)",
        fontSize: "1rem",
        color: "rgba(255,255,255,0.85)",
        marginBottom: "10px",
        letterSpacing: "0.08em"
      }}
    >
      Afterglo Beautyco
    </p>
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "22px",
        marginBottom: "14px"
      }}
    >
      <a
        href="https://www.instagram.com/afterglobeautyco/"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "var(--blush)",
          fontSize: "0.82rem",
          letterSpacing: "0.06em"
        }}
      >
        Instagram
      </a>
      <a
        href="mailto:afterglobeautyco@gmail.com"
        style={{
          color: "var(--blush)",
          fontSize: "0.82rem",
          letterSpacing: "0.06em"
        }}
      >
        Email
      </a>
      <a
        href="https://afterglobeautyco.square.site/"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "var(--blush)",
          fontSize: "0.82rem",
          letterSpacing: "0.06em"
        }}
      >
        Book
      </a>
    </div>
    <p>
      &copy; {new Date().getFullYear()} Afterglo Beautyco. All rights reserved.
    </p>
  </footer>
);

export default Footer;
